import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen hero-radial grain flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
        className="glass-strong rounded-3xl p-8 max-w-md w-full text-center"
      >
        <XCircle className="w-14 h-14 text-stone-400 mx-auto" />
        <h2 className="mt-3 font-serif text-3xl font-black text-stone-50">{t("payment.cancel_title")}</h2>
        <p className="mt-2 text-sm text-stone-400">{t("payment.cancel_text")}</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button onClick={() => navigate("/parental")} className="bg-amber-400 hover:bg-amber-300 text-stone-950 font-bold rounded-full px-6" data-testid="btn-back-parental">
            {t("payment.back_parental_btn")}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
